import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceAcknowledgementFragment = { readonly __typename?: 'SyncablePriceAcknowledgement', readonly id: string, readonly userId: string, readonly acknowledgedAt: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceAcknowledgementPullQueryVariables = Types.Exact<{
  input: Types.PullPriceAcknowledgementInput;
}>;


export type SyncPriceAcknowledgementPullQuery = { readonly __typename?: 'Query', readonly pullPriceAcknowledgement: { readonly __typename?: 'PullPriceAcknowledgementResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceAcknowledgement', readonly id: string, readonly userId: string, readonly acknowledgedAt: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncPriceAcknowledgementPushMutationVariables = Types.Exact<{
  input: Types.PushPriceAcknowledgementInput;
}>;


export type SyncPriceAcknowledgementPushMutation = { readonly __typename?: 'Mutation', readonly pushPriceAcknowledgement: { readonly __typename?: 'PushPriceAcknowledgementResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncablePriceAcknowledgement', readonly id: string, readonly userId: string, readonly acknowledgedAt: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceAcknowledgementFragmentDoc = gql`
    fragment WholeSyncablePriceAcknowledgement on SyncablePriceAcknowledgement {
  id
  userId
  acknowledgedAt
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceAcknowledgementPullDocument = gql`
    query SyncPriceAcknowledgementPull($input: PullPriceAcknowledgementInput!) {
  pullPriceAcknowledgement(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceAcknowledgement
    }
  }
}
    ${WholeSyncablePriceAcknowledgementFragmentDoc}`;

/**
 * __useSyncPriceAcknowledgementPullQuery__
 *
 * To run a query within a React component, call `useSyncPriceAcknowledgementPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceAcknowledgementPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceAcknowledgementPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceAcknowledgementPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceAcknowledgementPullQuery, SyncPriceAcknowledgementPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceAcknowledgementPullQuery, SyncPriceAcknowledgementPullQueryVariables>(SyncPriceAcknowledgementPullDocument, options);
      }
export function useSyncPriceAcknowledgementPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceAcknowledgementPullQuery, SyncPriceAcknowledgementPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceAcknowledgementPullQuery, SyncPriceAcknowledgementPullQueryVariables>(SyncPriceAcknowledgementPullDocument, options);
        }
export type SyncPriceAcknowledgementPullQueryHookResult = ReturnType<typeof useSyncPriceAcknowledgementPullQuery>;
export type SyncPriceAcknowledgementPullLazyQueryHookResult = ReturnType<typeof useSyncPriceAcknowledgementPullLazyQuery>;
export type SyncPriceAcknowledgementPullQueryResult = Apollo.QueryResult<SyncPriceAcknowledgementPullQuery, SyncPriceAcknowledgementPullQueryVariables>;
export const SyncPriceAcknowledgementPushDocument = gql`
    mutation SyncPriceAcknowledgementPush($input: PushPriceAcknowledgementInput!) {
  pushPriceAcknowledgement(input: $input) {
    rows {
      ...WholeSyncablePriceAcknowledgement
    }
  }
}
    ${WholeSyncablePriceAcknowledgementFragmentDoc}`;
export type SyncPriceAcknowledgementPushMutationFn = Apollo.MutationFunction<SyncPriceAcknowledgementPushMutation, SyncPriceAcknowledgementPushMutationVariables>;

/**
 * __useSyncPriceAcknowledgementPushMutation__
 *
 * To run a mutation, you first call `useSyncPriceAcknowledgementPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceAcknowledgementPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPriceAcknowledgementPushMutation, { data, loading, error }] = useSyncPriceAcknowledgementPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceAcknowledgementPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncPriceAcknowledgementPushMutation, SyncPriceAcknowledgementPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPriceAcknowledgementPushMutation, SyncPriceAcknowledgementPushMutationVariables>(SyncPriceAcknowledgementPushDocument, options);
      }
export type SyncPriceAcknowledgementPushMutationHookResult = ReturnType<typeof useSyncPriceAcknowledgementPushMutation>;
export type SyncPriceAcknowledgementPushMutationResult = Apollo.MutationResult<SyncPriceAcknowledgementPushMutation>;
export type SyncPriceAcknowledgementPushMutationOptions = Apollo.BaseMutationOptions<SyncPriceAcknowledgementPushMutation, SyncPriceAcknowledgementPushMutationVariables>;